export function mapboxErrorHandler({error}: ErrorEvent) {
    // HTTP errors already get printed to the console.
    if ('status' in error) return;
    else if (/http status 200 returned without content/i.test(error.message)) return;
    else if (/cancelled/i.test(error.message)) return;
    else {
        // Log it to console rather than throw, which might crash the map.
        // Sentry will pick it up.
        console.error('Mapbox error', error);
    }
}
